import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { changePassword, changeUsername, apiError } from "./adminApi";

export default function AdminSettings({ open, onOpenChange, username, onUsernameChanged }) {
  const [pwCur, setPwCur] = React.useState("");
  const [pwNew, setPwNew] = React.useState("");
  const [pwConf, setPwConf] = React.useState("");
  const [pwMsg, setPwMsg] = React.useState(null);

  const [unCur, setUnCur] = React.useState("");
  const [unNew, setUnNew] = React.useState("");
  const [unMsg, setUnMsg] = React.useState(null);

  const doPassword = async (e) => {
    e.preventDefault();
    setPwMsg(null);
    try {
      await changePassword({
        current_password: pwCur,
        new_password: pwNew,
        confirm_new_password: pwConf,
      });
      setPwMsg({ ok: true, text: "Password updated." });
      setPwCur("");
      setPwNew("");
      setPwConf("");
    } catch (err) {
      setPwMsg({ ok: false, text: apiError(err) });
    }
  };

  const doUsername = async (e) => {
    e.preventDefault();
    setUnMsg(null);
    try {
      const data = await changeUsername({ current_password: unCur, new_username: unNew });
      setUnMsg({ ok: true, text: "Username updated." });
      setUnCur("");
      setUnNew("");
      onUsernameChanged?.(data.username);
    } catch (err) {
      setUnMsg({ ok: false, text: apiError(err) });
    }
  };

  const input =
    "w-full rounded-lg border border-[#d7d6cf] px-3 py-2 text-sm outline-none focus:border-[#1b1b1b]";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-xl max-h-[90vh] overflow-y-auto" data-testid="admin-settings-modal">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold tracking-tight">Admin settings</DialogTitle>
          <DialogDescription className="text-sm text-[#75756f]">
            Signed in as <b>{username}</b>
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={doPassword} className="space-y-2 border-t border-[#eceae2] pt-4">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-[#75756f]">Change password</p>
          <input type="password" placeholder="Current password" value={pwCur} onChange={(e) => setPwCur(e.target.value)} className={input} data-testid="pw-current" />
          <input type="password" placeholder="New password" value={pwNew} onChange={(e) => setPwNew(e.target.value)} className={input} data-testid="pw-new" />
          <input type="password" placeholder="Confirm new password" value={pwConf} onChange={(e) => setPwConf(e.target.value)} className={input} data-testid="pw-confirm" />
          {pwMsg && (
            <p className={`text-sm ${pwMsg.ok ? "text-[#5f7d50]" : "text-red-600"}`} data-testid="pw-msg">
              {pwMsg.text}
            </p>
          )}
          <button type="submit" className="numex-cta w-full rounded-lg py-2.5 text-sm font-semibold tracking-widest" data-testid="pw-submit">
            UPDATE PASSWORD
          </button>
        </form>

        <form onSubmit={doUsername} className="space-y-2 border-t border-[#eceae2] pt-4">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-[#75756f]">Change username</p>
          <input type="password" placeholder="Current password" value={unCur} onChange={(e) => setUnCur(e.target.value)} className={input} data-testid="un-current" />
          <input placeholder="New username" value={unNew} onChange={(e) => setUnNew(e.target.value)} className={input} data-testid="un-new" />
          {unMsg && (
            <p className={`text-sm ${unMsg.ok ? "text-[#5f7d50]" : "text-red-600"}`} data-testid="un-msg">
              {unMsg.text}
            </p>
          )}
          <button type="submit" className="numex-cta w-full rounded-lg py-2.5 text-sm font-semibold tracking-widest" data-testid="un-submit">
            UPDATE USERNAME
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
